(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["far-eicma-2026-preview"] && !Shopify.designMode) return;
  try {
    
(()=>{function initialize(root){if(root.dataset.fecReady)return;root.dataset.fecReady='1';
/* 19/10/2026: il rimando scorre fino al modulo email in fondo alla pagina (sezione far-newsletter); su computer mette il cursore nel campo */
/* 19/10/2026 (Diego): chi lascia l'email arrivando dal rimando riceve anche l'etichetta «EICMA 2026» (campo nascosto contact[tags] del modulo in fondo) */
const segna=()=>{const t=document.getElementById('shopify-section-far-newsletter'),i=t&&t.querySelector('input[name="contact[tags]"]');if(i&&!/EICMA 2026/.test(i.value))i.value=(i.value?i.value+',':'')+'EICMA 2026';try{sessionStorage.setItem('far:eicma','1')}catch(e){}};
try{if(sessionStorage.getItem('far:eicma')==='1')segna()}catch(e){}
const link=root.querySelector('[data-fec-mail]');if(link){link.addEventListener('click',event=>{segna();const id=(link.getAttribute('href')||'').replace(/^#/,''),target=id&&document.getElementById(id);if(!target)return;event.preventDefault();target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});const input=target.querySelector('input[type="email"]');if(input&&matchMedia('(hover: hover)').matches)setTimeout(()=>input.focus({preventScroll:true}),750)})}
if('IntersectionObserver'in window&&!matchMedia('(prefers-reduced-motion: reduce)').matches){const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){root.classList.add('fec-enter');observer.disconnect()}},{threshold:.2});observer.observe(root)}}
function init(){document.querySelectorAll('[data-fec]').forEach(initialize)}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',event=>{const root=event.target.querySelector('[data-fec]');if(root)initialize(root)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["far-eicma-ruota"]) return;
  try {
    
(function(){
  function run(){
    var el=document.querySelector('[data-far-eicma-ruota]');
    if(!el) return;
    var on=false;
    try{
      if(new URLSearchParams(location.search).get('utm_source')==='eicma') sessionStorage.setItem('far:eicma-qr','1');
      on=sessionStorage.getItem('far:eicma-qr')==='1';
    }catch(e){ on=/[?&]utm_source=eicma(&|$)/.test(location.search); }
    if(!on) return;
    var form=document.querySelector('#MainContent form[action*="/cart/add"]');
    if(form){
      var host=form.closest('.product-form, .product__form, [class*="product-form"]')||form;
      if(host.parentNode) host.parentNode.insertBefore(el,host);
    }
    el.hidden=false;
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run,{once:true}); else run();
})();

  } catch(e) { console.error(e); }
})();
})();
